import React from "react";
import DevLibrary from "@/components/DevLibrary";

const CFG = {
  prefix: "fabrics",
  title: "New Fabric Development",
  subtitle: "A premium digital library of newly engineered fabrics",
  categories: ["Cotton", "Organic Cotton", "Supima Cotton", "Compact Cotton", "Lycra", "Cotton Lycra", "Polyester", "Nylon", "Viscose", "Modal", "Bamboo", "Terry", "French Terry", "Fleece", "Waffle", "Jacquard", "Rib", "Interlock", "Performance Fabric", "Recycled Fabric", "Experimental Fabric"],
  statuses: ["Research", "Under Development", "Testing", "Buyer Ready", "Production Ready"],
};

export default function FabricDevelopment() {
  return <DevLibrary cfg={CFG} />;
}
